import { create } from 'zustand';
import { DateRange } from 'react-day-picker';
import { ColumnState } from 'ag-grid-community';

import { defaultWMS2020_R01Dto, WMS2020_R01Dto } from './Dto_WMS2020_R01';
import { formatDateMonth, formatDateYear4, validateString } from 'src/utils/string/stringUtil';
import { showWarning } from 'src/utils/toast/toastUtil';

export interface WMS2020_R01Filter {
    logicCenter: string;
    warehouseCd: string;
    itemCd: string;
	itemNm: string;
    brandCd: string;
}

export interface WMS2020_R01ProcessFilter {
    logicCenter: string;
    warehouseCd: string;
	processType: string;
}

export interface Store_WMS2020_R01 {
	WMS2020_R01Filter: WMS2020_R01Filter;
	WMS2020_R01PastFilter: WMS2020_R01Filter;
	setWMS2020_R01Filter: (filter: Partial<WMS2020_R01Filter>) => void;
	setWMS2020_R01PastFilter: (filter: Partial<WMS2020_R01Filter>) => void;

	WMS2020_R01ProcessFilter: WMS2020_R01ProcessFilter;
	setWMS2020_R01ProcessFilter: (filter: Partial<WMS2020_R01ProcessFilter>) => void;

	WMS2020_R01List: WMS2020_R01Dto[];
	setWMS2020_R01List: (WMS2020_R01List: WMS2020_R01Dto[]) => void;
	insertWMS2020_R01List: (data: WMS2020_R01Dto[], index?: number) => void;
	removeWMS2020_R01List: (index: number) => void;
	updateWMS2020_R01List: (index: number, WMS2020_R01List: WMS2020_R01Dto) => void;

	deletedWMS2020_R01List: string[];
	addDeletedWMS2020_R01List: (idList: string[]) => void;
	removeDeletedWMS2020_R01List: (idList?: string[]) => void;

	selectedWMS2020_R01List: string[];
	setSelectedWMS2020_R01List: (idList: string[]) => void;
	addSelectedWMS2020_R01List: (idList: string[]) => void;
	removeSelectedWMS2020_R01List: (idList?: string[]) => void;
	initSelectedWMS2020_R01List: () => void;
	allSelectedWMS2020_R01List: () => void;

	
	WMS2020_R01DetailList: WMS2020_R01Dto[];
	setWMS2020_R01DetailList: (WMS2020_R01DetailList: WMS2020_R01Dto[]) => void;
	insertWMS2020_R01DetailList: (data: WMS2020_R01Dto[], index?: number) => void;
	removeWMS2020_R01DetailList: (index: number) => void;
	updateWMS2020_R01DetailList: (index: number, WMS2020_R01DetailList: WMS2020_R01Dto) => void;
	
	deletedWMS2020_R01DetailList: string[];
	addDeletedWMS2020_R01DetailList: (idList: string[]) => void;
	removeDeletedWMS2020_R01DetailList: (idList?: string[]) => void;

	selectedWMS2020_R01DetailList: string[];
	setSelectedWMS2020_R01DetailList: (idList: string[]) => void;
	addSelectedWMS2020_R01DetailList: (idList: string[]) => void;
	removeSelectedWMS2020_R01DetailList: (idList?: string[]) => void;
	initSelectedWMS2020_R01DetailList: () => void;
	allSelectedWMS2020_R01DetailList: () => void;

	originalWMS2020_R01List: WMS2020_R01Dto[];
	setOriginalWMS2020_R01List: (list: WMS2020_R01Dto[]) => void;

	
	originalWMS2020_R01DetailList: WMS2020_R01Dto[];
	setOriginalWMS2020_R01DetailList: (list: WMS2020_R01Dto[]) => void;

	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;
	

	initData: () => void;

}

export const defaultWMS2020_R01Filter: WMS2020_R01Filter = {
	logicCenter: '',
	warehouseCd: '',
	itemCd: '',
	itemNm: '',
	brandCd: '',
};

export const defaultWMS2020_R01ProcessFilter: WMS2020_R01ProcessFilter = {
	logicCenter: '',
	warehouseCd: '',
	processType: 'move',
};

export const processTypeMap_WMS2020_R01 = [
	{ title: 'Lot 이동', value: 'move' },
	{ title: 'Lot 분할', value: 'split' },
]

//detailList 초기화: 이동량 0으로 고정
const initDetailList = (list: WMS2020_R01Dto[], _processFilter: WMS2020_R01ProcessFilter): WMS2020_R01Dto[] => {
	const newDetailList = list
							.map(item => ({ ...defaultWMS2020_R01Dto, ...item, movedLotQty: 0 }))
							.map(item => applyFilterToDetailList(item, _processFilter));
	return newDetailList;
}

//processFilter의 창고번호, 물류센터 적용
const applyFilterToDetailList = (item: WMS2020_R01Dto, _processFilter: WMS2020_R01ProcessFilter): WMS2020_R01Dto => {
	return {
		...item,
		logicCenter: validateString(_processFilter.logicCenter) ? _processFilter.logicCenter : item.logicCenter,
		warehouseCd: validateString(_processFilter.logicCenter) ? _processFilter.warehouseCd : item.warehouseCd,
		movedLotQty: _processFilter.processType === 'move' ? item.lotQty : 0,
	};
}
export const useWMS2020_R01Store = create<Store_WMS2020_R01>((set) => ({
	WMS2020_R01Filter: defaultWMS2020_R01Filter,
	WMS2020_R01PastFilter: defaultWMS2020_R01Filter,
	setWMS2020_R01Filter: (update) => set((state) => ({
		WMS2020_R01Filter: {
			...state.WMS2020_R01Filter,
			...update
		}
	})),
	setWMS2020_R01PastFilter: (update) => set((state) => ({
		WMS2020_R01PastFilter: {
			...state.WMS2020_R01PastFilter,
			...update
		}
	})),

	WMS2020_R01ProcessFilter: defaultWMS2020_R01ProcessFilter,
	setWMS2020_R01ProcessFilter: (update) => set((state) => {

		const newWMS2020_R01ProcessFilter = { ...state.WMS2020_R01ProcessFilter, ...update };
		const newDetailList = state.WMS2020_R01DetailList
								.map(item => applyFilterToDetailList(item, newWMS2020_R01ProcessFilter))
								.map(item => ({ 
												...item, 
												movedLotQty: newWMS2020_R01ProcessFilter.processType === 'move' ? item.lotQty : 0 
								}));

		return {
			...state,
			WMS2020_R01ProcessFilter: newWMS2020_R01ProcessFilter,
			WMS2020_R01DetailList: newDetailList
		}
	}),

	WMS2020_R01List: [],
	setWMS2020_R01List: (WMS2020_R01List: WMS2020_R01Dto[]) => set((state) => {
		let newList: WMS2020_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		WMS2020_R01List.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				...defaultWMS2020_R01Dto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			WMS2020_R01List: newList
		}
	}),
	insertWMS2020_R01List: (data: WMS2020_R01Dto[], index?: number) => set((state) => {
		let newWMS2020_R01List = [...state.WMS2020_R01List];

		let targetRowData = newWMS2020_R01List.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newWMS2020_R01List.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newWMS2020_R01List.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newWMS2020_R01List = newWMS2020_R01List.filter(item => item.orderIndex !== targetOrderIndex);
		newWMS2020_R01List.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultWMS2020_R01Dto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newWMS2020_R01List.splice(index, 0, ...newData);
		} else {
			newWMS2020_R01List.push(...newData);
		}

		return {
			...state,
			WMS2020_R01List: newWMS2020_R01List
		}
	}),
	removeWMS2020_R01List: (index: number) => set((state) => {
		const newWMS2020_R01List = [...state.WMS2020_R01List].filter((item) => item.valueIndex !== index);
		return {
			...state,
			WMS2020_R01List: newWMS2020_R01List
		}
	}),
	updateWMS2020_R01List: (valueIndex: number, data: WMS2020_R01Dto) => set((state) => {
		const _WMS2020_R01List = state.WMS2020_R01List;
		return {
			...state,
			WMS2020_R01List: _WMS2020_R01List,
		}
	}),


	deletedWMS2020_R01List: [],
	addDeletedWMS2020_R01List: (idList: string[]) => set((state) => {
		const _deletedWMS2020_R01List = [...state.deletedWMS2020_R01List];

		for(const valueIndex of idList) {
			const isInserted = state.WMS2020_R01List.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.WMS2020_R01List.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedWMS2020_R01List.push(valueIndex);
			}
		}
		return {
			...state,
			deletedWMS2020_R01List: _deletedWMS2020_R01List
		}
	}),
	removeDeletedWMS2020_R01List: (idList?: string[]) => set((state) => ({
		...state,
		deletedWMS2020_R01List: [...state.deletedWMS2020_R01List].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedWMS2020_R01List: [],
	setSelectedWMS2020_R01List: (idList: string[]) => set((state) => {

		const newDetailList: WMS2020_R01Dto[] = [];

		idList.forEach(value => {
			const selectedRow = state.WMS2020_R01List.find(item => item.valueIndex === Number(value));
			if(selectedRow) {
				newDetailList.push(selectedRow);
			}
		});
		newDetailList.forEach(item => { item.movedLotQty = 0; });
		return {
			...state,
			selectedWMS2020_R01List: idList,
			WMS2020_R01DetailList: initDetailList(newDetailList, state.WMS2020_R01ProcessFilter),
			detailScrollTop: null,
		}
	}),
	addSelectedWMS2020_R01List: (idList: string[]) => set((state) => {
		const _selectedWMS2020_R01List = [...state.selectedWMS2020_R01List];
		const _processFilter = state.WMS2020_R01ProcessFilter;
		//명시적으로 idList의 요소를 String으로 변환하고 _selectedWMS2020_R01List에 추가
		if(idList.length > 0) {
			_selectedWMS2020_R01List.push(...idList);
		}

		const newIdListString = idList.map(String);
		
		// 새로 추가할 항목만 원본 리스트에서 찾음
		const newItems: WMS2020_R01Dto[] = [];
		state.WMS2020_R01List.forEach(item => {
			if(newIdListString.includes(item.valueIndex.toString())) {
				newItems.push(item);
			}
		});

		// 기존 리스트는 유지하고, 새로운 항목만 초기화(movedLotQty=0)하여 추가
		const newDetailList: WMS2020_R01Dto[] = [
			...state.WMS2020_R01DetailList,
			...newItems
		].map(item => applyFilterToDetailList(item, _processFilter));

		return {
			...state,
			selectedWMS2020_R01List: _selectedWMS2020_R01List,
			WMS2020_R01DetailList: newDetailList,
			detailScrollTop: null,
		}
	}),
	removeSelectedWMS2020_R01List: (idList?: string[]) => set((state) => {
		const _selectedWMS2020_R01List = [...state.selectedWMS2020_R01List].filter(value => idList ? !idList.includes(value) : false);
		const _processFilter = state.WMS2020_R01ProcessFilter;

		const selectedWMS2020_R01ListString = _selectedWMS2020_R01List.map(String);
		const _WMS2020_R01DetailList = [...state.WMS2020_R01DetailList].filter(item => selectedWMS2020_R01ListString.includes(item.valueIndex.toString()))
		.map(item => applyFilterToDetailList(item, _processFilter));

		return {
			...state,
			selectedWMS2020_R01List: _selectedWMS2020_R01List,
			WMS2020_R01DetailList: _WMS2020_R01DetailList,
			detailScrollTop: null,
		}
	}),
	initSelectedWMS2020_R01List: () => set((state) => ({
		...state,
		selectedWMS2020_R01List: [],
		WMS2020_R01DetailList: [],
		detailScrollTop: null,
	})),
	allSelectedWMS2020_R01List: () => set((state) => {
		const allIdList = state.WMS2020_R01List.map(item => item.valueIndex as any);
		const _processFilter = state.WMS2020_R01ProcessFilter;

		// 모든 항목을 초기화(movedLotQty=0)하여 추가
		const newDetailList = state.WMS2020_R01List.map(item => 
			applyFilterToDetailList({ ...item, movedLotQty: 0 }, _processFilter)
		);

		return {
			...state,
			selectedWMS2020_R01List: allIdList,
			WMS2020_R01DetailList: newDetailList,
			detailScrollTop: null,
		};
	}),

	WMS2020_R01DetailList: [],
	setWMS2020_R01DetailList: (WMS2020_R01DetailList: WMS2020_R01Dto[]) => set((state) => { return { ...state, WMS2020_R01DetailList: WMS2020_R01DetailList } }),
	insertWMS2020_R01DetailList: (data: WMS2020_R01Dto[], index?: number) => set((state) => {

		let newWMS2020_R01DetailList = [...state.WMS2020_R01DetailList];
		let targetRowData = newWMS2020_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		let maxValueIndex = Math.max(0, ...newWMS2020_R01DetailList.map(item => item.valueIndex || 0)) + 1;
		const targetRows = newWMS2020_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);

		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		newWMS2020_R01DetailList = newWMS2020_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newWMS2020_R01DetailList.push(...targetRows);

		const newData = data.map(item => ({ ...defaultWMS2020_R01Dto, ...item, valueIndex: maxValueIndex++, orderIndex: targetOrderIndex, orderIndexSeq: newOrderIndexSeq }));
		if (index !== undefined) {
			newWMS2020_R01DetailList.splice(index, 0, ...newData);
		} else {
			newWMS2020_R01DetailList.push(...newData);
		}

		return { ...state, WMS2020_R01DetailList: newWMS2020_R01DetailList };
	}),
	removeWMS2020_R01DetailList: (index: number) => set((state) => {
		const newWMS2020_R01DetailList = [...state.WMS2020_R01DetailList].filter((item) => item.valueIndex !== index);
		return { ...state, WMS2020_R01DetailList: newWMS2020_R01DetailList };
	}),
	updateWMS2020_R01DetailList: (valueIndex: number, data: WMS2020_R01Dto) => set((state) => {
		// [수정] 불변성 유지를 위해 map 사용
		const _WMS2020_R01DetailList = state.WMS2020_R01DetailList.map(item => {
			if(item.valueIndex === valueIndex) {
				return { ...item, movedLotQty: data.movedLotQty };
			}
			return item;
		});

		console.log('updateWMS2020_R01DetailList', valueIndex, data.movedLotQty);

		return { ...state, WMS2020_R01DetailList: _WMS2020_R01DetailList };
	}),

	
	deletedWMS2020_R01DetailList: [],
	addDeletedWMS2020_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedWMS2020_R01DetailList = [...state.deletedWMS2020_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.WMS2020_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.WMS2020_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedWMS2020_R01DetailList.push(valueIndex);
			}
		}
		return {
			...state,
			deletedWMS2020_R01DetailList: _deletedWMS2020_R01DetailList
		}
	}),
	removeDeletedWMS2020_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedWMS2020_R01DetailList: [...state.deletedWMS2020_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedWMS2020_R01DetailList: [],
	setSelectedWMS2020_R01DetailList: (idList: string[]) => set({ selectedWMS2020_R01DetailList: idList }),
	addSelectedWMS2020_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedWMS2020_R01DetailList = [...state.selectedWMS2020_R01DetailList];
		if(idList.length > 0) {
			_selectedWMS2020_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedWMS2020_R01DetailList: _selectedWMS2020_R01DetailList
		}
	}),
	removeSelectedWMS2020_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedWMS2020_R01DetailList: [...state.selectedWMS2020_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedWMS2020_R01DetailList: () => set({ selectedWMS2020_R01DetailList: [] }),
	allSelectedWMS2020_R01DetailList: () => set((state) => {
		const _selectedWMS2020_R01DetailList = [...state.WMS2020_R01DetailList.map(item => item.valueIndex.toString())];
		return {
			...state,
			selectedWMS2020_R01DetailList: _selectedWMS2020_R01DetailList.map(item => item.toString())
		}
	}),

	originalWMS2020_R01List: [],
	setOriginalWMS2020_R01List: (WMS2020_R01List: WMS2020_R01Dto[]) => set((state) => {
		let newList: WMS2020_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		WMS2020_R01List.forEach((item, index) => {
			newList.push({ 
				...defaultWMS2020_R01Dto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalWMS2020_R01List: newList
		}
	}),

	originalWMS2020_R01DetailList: [],
	setOriginalWMS2020_R01DetailList: (WMS2020_R01DetailList: WMS2020_R01Dto[]) => set((state) => {
		let newList: WMS2020_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		WMS2020_R01DetailList.forEach((item, index) => {
			newList.push({ 
				...defaultWMS2020_R01Dto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalWMS2020_R01DetailList: newList
		}
	}),

	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
						

	initData: () => set((state) => ({
		...state,
		WMS2020_R01Filter: defaultWMS2020_R01Filter,
		WMS2020_R01PastFilter: defaultWMS2020_R01Filter,
		WMS2020_R01ProcessFilter: defaultWMS2020_R01ProcessFilter,

		WMS2020_R01List: [],
		selectedWMS2020_R01List: [],
		deletedWMS2020_R01List: [],

		WMS2020_R01DetailList: [],
		deletedWMS2020_R01DetailList: [],
		selectedWMS2020_R01DetailList: [],

		originalWMS2020_R01List: [],
		originalWMS2020_R01DetailList: [],

		allCount: 0,
		scrollTop: null,
		detailScrollTop: null,
	})),

}));